var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "m-1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2013_6136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.53092 7.16679V6.50013C6.53092 6.14651 6.3933 5.80737 6.14833 5.55732C5.90337 5.30727 5.57113 5.16679 5.22469 5.16679H2.61225C2.26582 5.16679 1.93358 5.30727 1.68861 5.55732C1.44365 5.80737 1.30603 6.14651 1.30603 6.50013V7.16679",
    stroke: "#9E9E9E",
    strokeWidth: 0.635188,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91914 3.83335C4.64054 3.83335 5.22536 3.2364 5.22536 2.50002C5.22536 1.76364 4.64054 1.16669 3.91914 1.16669C3.19773 1.16669 2.61292 1.76364 2.61292 2.50002C2.61292 3.2364 3.19773 3.83335 3.91914 3.83335Z",
    stroke: "#9E9E9E",
    strokeWidth: 0.635188,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2013_6136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.83733,
    height: 8,
    fill: "white",
    transform: "translate(0.00012207 0.166779)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser2);
export default __webpack_public_path__ + "static/media/user2.0c3adaa8a57ac1dc06f67399f02f6852.svg";
export { ForwardRef as ReactComponent };